module.exports = __webpack_public_path__ + "img/liuyanfei.b51bf87c.png";